export default __webpack_public_path__ + "static/media/banner-img.abeacc92.svg";